// extracted by mini-css-extract-plugin
module.exports = {"searchHorizontalRecosContainer":"yW","reco":"zW","products":"AW"};